import { render, staticRenderFns } from "./import-tab.vue?vue&type=template&id=4bd1f59e&scoped=true&"
import script from "./import-tab.vue?vue&type=script&lang=js&"
export * from "./import-tab.vue?vue&type=script&lang=js&"
import style0 from "./import-tab.vue?vue&type=style&index=0&id=4bd1f59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1f59e",
  null
  
)

export default component.exports